import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import React from 'react';
import {Outlet, useLocation} from 'react-router-dom';

import {AppBarV2} from '../components/AppBar';
import MenuBarV2 from '../components/MenuBarV2';
import {FOOTER_HEIGHT, WHITE_100} from '../theme';

const ALPHA_ENV_FOOTER = '#2A3C82';
const DEV_ENV_FOOTER = '#823C2A';

const ENV_FOOTER_BOX_PROPS = {
  alignItems: 'center',
  bottom: 0,
  color: WHITE_100,
  display: 'flex',
  height: FOOTER_HEIGHT,
  justifyContent: 'center',
  position: 'fixed',
  sx: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    textAlign: 'center',
  },
  width: '100%',
  zIndex: 999,
};

function EnvironmentFooter() {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'production':
      return null;
    case 'staging':
      return (
        <Box {...ENV_FOOTER_BOX_PROPS} bgcolor={ALPHA_ENV_FOOTER}>
          <Typography>
            This is the <strong>STAGING</strong> environment.
          </Typography>
        </Box>
      );
    default:
      return (
        <Box {...ENV_FOOTER_BOX_PROPS} bgcolor={DEV_ENV_FOOTER}>
          <Typography>
            This is a{' '}
            <strong>
              {_.toUpper(process.env.REACT_APP_ENVIRONMENT) || 'DEV'}
            </strong>{' '}
            environment.
          </Typography>
        </Box>
      );
  }
}

const DefaultLayout = () => {
  const {pathname} = useLocation();

  return (
    <Stack direction="column" height="100vh" width="100vw">
      <Stack
        direction="row"
        height="100%"
        maxHeight={`calc(100% - ${FOOTER_HEIGHT})`}
        width="100%"
      >
        <AppBarV2 />
        {!pathname.startsWith('/disclosure-library') && <MenuBarV2 />}
        <Outlet />
      </Stack>
      <EnvironmentFooter />
    </Stack>
  );
};

export default DefaultLayout;
